import { render, staticRenderFns } from "./CollectionsList.vue?vue&type=template&id=3ba90478&scoped=true&"
import script from "./CollectionsList.vue?vue&type=script&lang=js&"
export * from "./CollectionsList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsList.vue?vue&type=style&index=0&id=3ba90478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba90478",
  null
  
)

export default component.exports